/**
 * Chooses the page for /bom-approval/:assemblyId and /assembly-results/:assemblyId.
 * tariff_v2 records open BOMApprovalV2Page (approval and results in one page);
 * every other record opens the unchanged v1 page passed as `legacy`.
 */

import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import BOMApprovalV2Page from './BOMApprovalV2Page';

const BASE_URL = process.env.REACT_APP_BE_MAIN_URL;

export default function AssemblyPageSwitch({ legacy: Legacy }) {
    const { assemblyId } = useParams();
    const [playId, setPlayId] = useState(null);

    useEffect(() => {
        let alive = true;
        axios.get(`${BASE_URL}/ocr/assembly-analysis/${assemblyId}/`,
            { headers: { Authorization: `Bearer ${sessionStorage.getItem('userToken')}` } })
            .then((res) => alive && setPlayId(res.data?.play_id || 'unknown'))
            .catch(() => alive && setPlayId('unknown'));   // the legacy page shows its own error
        return () => { alive = false; };
    }, [assemblyId]);

    if (playId === null) {
        return (
            <div className="min-h-screen bg-[#f6f4ed] flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#1e5045]" />
            </div>
        );
    }
    return playId === 'tariff_v2' ? <BOMApprovalV2Page key={assemblyId} /> : <Legacy key={assemblyId} />;
}
